<template>
  <div>
    <v-container class="content-wrapper" fluid id="hosting-institution-tab">
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="12" md="6" class="justify-center d-flex">
          <v-btn-toggle v-model="toggleButton" rounded mandatory>
            <v-btn value="providers" class="btn-selected">
              Providers
            </v-btn>
            <v-btn value="services" class="btn-selected">
              Services
            </v-btn>
            <v-btn value="equipment" class="btn-selected">
              Equipment
            </v-btn>
            <v-btn value="patents" class="btn-selected">
              Patents
            </v-btn>
          </v-btn-toggle>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <!-- Providers -->
      <v-row v-if="toggleButton === 'providers'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Providers
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'providers'">
        <v-col cols="12" lg="10">
          <MarketplaceProvidersFilteredViewAll
            :filteredParams="params"
          ></MarketplaceProvidersFilteredViewAll>
        </v-col>
      </v-row>

      <!-- Services -->
      <v-row v-if="toggleButton === 'services'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Services
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'services'">
        <v-col cols="12" lg="10">
          <v-row>
            <MarketplaceServicesFilteredViewAll
              :filteredParams="params"
            ></MarketplaceServicesFilteredViewAll>
          </v-row>
        </v-col>
      </v-row>

      <!-- Equipment -->
      <v-row v-if="toggleButton === 'equipment'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Equipment
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'equipment'">
        <v-col cols="12" lg="10">
          <v-row>
            <MarketplaceEquipmentFilteredViewAll
              :filteredParams="params"
            ></MarketplaceEquipmentFilteredViewAll>
          </v-row>
        </v-col>
      </v-row>

      <!-- Patents -->
      <v-row v-if="toggleButton === 'patents'">
        <v-spacer></v-spacer>
        <v-col cols="12" xl="11" lg="11" md="12" sm="12" xs="12">
          <h2 class="black--text font-weight-bold">
            Patents
          </h2>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="toggleButton === 'patents'">
        <v-col cols="12" lg="10">
          <v-row>
            <MarketplacePatentsFilteredViewAll
              :filteredParams="params"
            ></MarketplacePatentsFilteredViewAll>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MarketplaceEquipmentFilteredViewAll from '../marketplace/MarketplaceEquipmentFilteredViewAll.vue';
import MarketplaceProvidersFilteredViewAll from '../marketplace/MarketplaceProvidersFilteredViewAll.vue';
import MarketplaceServicesFilteredViewAll from '../marketplace/MarketplaceServicesFilteredViewAll.vue';
import MarketplacePatentsFilteredViewAll from '../marketplace/MarketplacePatentsFilteredViewAll.vue';

export default {
  name: 'HostingRepresentativeMyResources',
  components: {
    MarketplaceEquipmentFilteredViewAll,
    MarketplaceProvidersFilteredViewAll,
    MarketplaceServicesFilteredViewAll,
    MarketplacePatentsFilteredViewAll,
  },
  data: () => ({
    toggleButton: 'providers',
    params: {},
  }),
  // watch: {
  //   '$route.query.toggleButton'(newValue) {
  //     if (newValue) {
  //       this.toggleButton = newValue;
  //     }
  //   },
  // },
  // mounted() {
  //   if (this.$route.query.toggleButton) {
  //     this.toggleButton = this.$route.query.toggleButton;
  //   }
  // },
  created() {
    const institutionId = localStorage.getItem('representativeId');

    this.params = {
      institutions: institutionId,
    };
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
